/** Matches packages/cfg LOCAL_TUNNEL_BASE_DOMAIN — kept inline to avoid a direct pp-cfg dep in NF. */
const LOCAL_TUNNEL_BASE_DOMAIN = 'local.perpetualpress.io'

/**
 * Base URL for local widget assets (JS/CSS/version manifest).
 * When NF is opened via the Cloudflare tunnel host, use the tunnel widget
 * origin so Chrome does not prompt for Local Network Access to localhost.
 * Plain localhost NF keeps localhost:4500 for UI tests / direct local runs.
 *
 * @returns {string} e.g. https://widget.usyyid.local.perpetualpress.io or http://localhost:4500
 */
export function getLocalWidgetBaseUrl() {
  if (typeof window !== 'undefined') {
    const host = String(window.location.hostname || '').toLowerCase()
    if (host === LOCAL_TUNNEL_BASE_DOMAIN) {
      return `https://widget.${LOCAL_TUNNEL_BASE_DOMAIN}`
    }
    if (host.endsWith(`.${LOCAL_TUNNEL_BASE_DOMAIN}`)) {
      // nf.{zone} → widget.{zone} (zone is usyyid.local.perpetualpress.io or local.perpetualpress.io)
      const zone = host.split('.').slice(1).join('.')
      return `https://widget.${zone}`
    }
  }
  return 'http://localhost:4500'
}
